import __vue_component__ from './TextField.vue.js';

//
const ENTER = 13;
var script = {
  name: 'TextArea',
  components: {
    TextField: __vue_component__
  },
  props: {
    value: {
      type: String,
      required: true
    },
    isFocused: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    height: {
      type: [Number, String],
      default: 'auto'
    },
    maxHeight: {
      type: [Number, String],
      default: 'auto'
    },
    width: {
      type: [Number, String],
      default: '100%'
    },
    rows: {
      type: String,
      default: '1'
    },
    submitOnEnter: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentHeight: this.height,
      focused: this.isFocused
    };
  },

  computed: {
    listeners() {
      const {
        input,
        ...listeners
      } = this.$listeners;
      return listeners;
    },

    text: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit('input', value);
      }

    }
  },
  watch: {
    isFocused: {
      handler() {
        this.focused = this.isFocused;

        if (this.focused) {
          this.$nextTick(() => this.$refs.textarea.focus());
        }
      },

      immediate: true
    }
  },

  mounted() {
    if (this.height === 'auto') {
      this.currentHeight = `${this.$refs.textarea.scrollHeight}px`;
    }
  },

  methods: {
    onBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
    },

    onFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },

    resize(e) {
      if (this.submitOnEnter && e.keyCode === ENTER) {
        this.$emit('confirm');
        return;
      }

      if (this.height === 'auto') {
        this.currentHeight = 'auto';
        this.$nextTick(() => {
          if (this.$refs.textarea) {
            this.currentHeight = `${this.$refs.textarea.scrollHeight}px`;
          }
        });
      }
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Form/TextArea.vue_rollup-plugin-vue=script.js